import React from 'react'
import { LuAward, LuBrain, LuClock4, LuCompass, LuFingerprint, LuMap, LuNavigation, LuShieldAlert, LuSun, LuUser, LuZap } from 'react-icons/lu'
import waste from "../../../images/students/waste.webp"
import zap from "../../../images/students/zap.webp"


export default function Gives() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 w-full overflow-hidden text-center bg-[#FAFCFF]'>
            <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>₹499 GIVES YOU:</h3>
            <div className='flex gap-[20px] md:gap-[60px] items-center justify-center md:w-11/12 lg:w-9/12 mx-auto flex-wrap text-[#323232] text-[16px] md:text-[22px] font-semibold mt-[20px] md:mt-[40px]'>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#DBEAFE] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuCompass className='text-[15px] md:text-[25px] text-[#155DFC]' />
                    </div>
                    <p>Direction</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#FEF9C2] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuSun className='text-[15px] md:text-[25px] text-[#D08700]' />
                    </div>
                    <p>Clarity</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#F3E8FF] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuBrain className='text-[15px] md:text-[25px] text-[#9810FA]' />
                    </div>
                    <p>Mindset</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#FCE7F3] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuMap className='text-[15px] md:text-[25px] text-[#E60076]' />
                    </div>
                    <p>Skill Pathways</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#FFE2E2] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuClock4 className='text-[15px] md:text-[25px] text-[#E7000B]' />
                    </div>
                    <p>Discipline</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#FFEDD4] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuUser className='text-[15px] md:text-[25px] text-[#D08700]' />
                    </div>
                    <p>Community</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#E0E7FF] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuNavigation className='text-[15px] md:text-[25px] text-[#9810FA]' />
                    </div>
                    <p>Guidance</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#CBFBF1] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuAward className='text-[15px] md:text-[25px] text-[#009689]' />
                    </div>
                    <p>Confidence</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#CEFAFE] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuFingerprint className='text-[15px] md:text-[25px] text-[#0092B8]' />
                    </div>
                    <p>Identity</p>
                </div>
                <div className='flex gap-[8px] md:gap-[16px] items-center'>
                    <div className='bg-[#DCFCE7] size-[30px] md:size-[54px] rounded-[8px] md:rounded-[16px] flex justify-center items-center'>
                        <LuZap className='text-[15px] md:text-[25px] text-[#00A63E]' />
                    </div>
                    <p>Capability</p>
                </div>
            </div>
            <div className='border border-[#FFE2E2] rounded-[14px] md:rouneded-[28px] xl:rounded-[40px] p-[20px] md:px-[58px] md:py-[32px]  mt-[32px] md:mt-[56px]'>
                <div className='w-max mx-auto rounded-full bg-[#FFE2E2] px-[12px] py-[6px] md:py-[11px] md:px-[24px] flex gap-[7px] md:gap-[14px] items-center text-[#9F0712] font-bold text-[14px] md:text-[24px]'>
                    <LuShieldAlert />
                    Why Not Free?
                </div>
                <div className='grid xl:grid-cols-2 gap-[14px] md:gap-[28px] mt-[15px] md:mt-[30px] mx-auto'>
                    <div className=' w-full bg-[#FEF2F2] border border-[#FFE2E2] rounded-[12px] md:rounded-[21px] p-[20px] md:py-[50px]' style={{ boxShadow: "0px 2px 5px 0px #0000001A" }}>
                       <img src={waste} alt='waste' loading='lazy' className='mx-auto'/>
                       <p className='mt-[6px] md:mt-[12px] text-[#6A7282] text-[16px] md:text-[22px] font-medium'>Entertainment</p>
                       <p className='text-[#101828] mt-[6px] md:mt-[12px] font-bold text-[24px] md:text-[38px]'>OTT Platforms</p>
                       <p className='text-[#101828] mt-[6px] md:mt-[12px] font-bold text-[32px] md:text-[57px]'>₹499</p>
                    </div>
                    <div className=' w-full bg-[#34C7590D] border border-[#B0E4C0] rounded-[12px] md:rounded-[21px] p-[20px] md:py-[50px]' style={{ boxShadow: "0px 2px 5px 0px #0000001A" }}>
                       <img src={zap} alt='zap' loading='lazy' className='mx-auto'/>
                       <p className='mt-[6px] md:mt-[12px] text-[#009626] text-[16px] md:text-[22px] font-medium'>Empowerment</p>
                       <p className='text-[#34C759] mt-[6px] md:mt-[12px] font-bold text-[24px] md:text-[38px]'>Surge Students</p>
                       <p className='text-[#34C759] mt-[6px] md:mt-[12px] font-bold text-[32px] md:text-[57px]'>₹499</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
